/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：159
 */

module.exports = {
  hide: "style_hide__Y6gh1",
  "coco-widget-wrapper": "style_coco-widget-wrapper__1ESr6",
  "coco-child-widget": "style_coco-child-widget__HyDBB",
  "coco-child-widget-selected": "style_coco-child-widget-selected__2o1Fh",
  "coco-child-widget-full": "style_coco-child-widget-full__f1rza",
  sliderBox: "style_sliderBox__3jnH-",
  main: "style_main__1hVYe",
  step: "style_step__2MwVy",
  trackBox: "style_trackBox__2MkLY",
  track: "style_track__I9eaf",
  horizontalTrackBox: "style_horizontalTrackBox__2ntrm",
  verticalTrackBox: "style_verticalTrackBox__32ko8",
  handle: "style_handle__3NPIU",
  templateHandle: "style_templateHandle__2Yglu",
  horizontalHandle: "style_horizontalHandle__3iSOw",
  handleInner: "style_handleInner__1a2Ye",
  verticalHandle: "style_verticalHandle__2kGtH",
  imageHandle: "style_imageHandle__1TkZX",
  horizontalRotate: "style_horizontalRotate__23nkJ",
  verticalRotate: "style_verticalRotate__36-mC",
  handleNotSelected: "style_handleNotSelected__3Jy3L"
}
